import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getJStoreList } from '@/service/components';

// ==================== 数据处理函数 ====================

// 处理不同数据类型的数据
const processSingleDataType = ({ data, dataType }) => {
  let list = data
  if (list && !Array.isArray(list) && Array.isArray(list.records)) {
    list = list.records
  }
  if (!Array.isArray(list)) return [];

  // 如果没有指定 dataType 或为空，直接返回原始数据
  if (!dataType || dataType === 'default') {
    return list;
  }

  const toStoreOption = (item) => ({
    id: `${item.value}`,
    value: item.label
  });

  switch (dataType) {
    case 'option':
      return list.map(toStoreOption);
    case 'optionErp':
      return list.filter((item) => item.extra === 'erp').map(toStoreOption);
    case 'optionTuina':
      return list.filter((item) => item.extra === 'tuina').map(toStoreOption);
    default:
      return list;
  }
};

// ==================== 初始状态 ====================
const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: []  // 列表数据初始化为空数组
}

// ==================== 异步 Actions ====================
export const fetchJStoreList = createAsyncThunk(
  'getJStoreList/fetchJStoreList',
  async ({ query = {}, dataType } = {}, { rejectWithValue }) => {
    try {
      const response = await getJStoreList(query);
      return {
        data: response.data,
        query,
        dataType
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取门店列表失败');
    }
  }
)

// ==================== Slice 定义 ====================
const getJStoreListSlice = createSlice({
  name: 'getJStoreList',
  initialState: defaultState,
  reducers: {
    resetJStoreListState: (state, action) => {
      state.query = {};
      state.data = [];  // 重置为空数组
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJStoreList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        const arg = action.meta?.arg || {};
        state.query = arg.query || {};
        state.data = [];  // 请求开始时清空列表
      })
      .addCase(fetchJStoreList.fulfilled, (state, action) => {
        const { data, dataType, query } = action.payload || {};
        state.fetching = false;
        state.error = null;
        state.query = query || {};
        state.data = processSingleDataType({ data, dataType });
      })
      .addCase(fetchJStoreList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = [];  // 失败时重置为空数组
      });
  }
})

// ==================== 导出 ====================
export const { resetJStoreListState } = getJStoreListSlice.actions;
export default getJStoreListSlice.reducer;
